export const TYPES = {
  LearningGuideService: Symbol.for('learningGuide/LearningGuideService'),
  LearningGuideMenuItemService: Symbol.for('learningGuide/LearningGuideMenuItemService'),
  LearningGuideController: Symbol.for('learningGuide/LearningGuideController'),
  LearningGuideStore: Symbol.for('learningGuide/LearningGuideStore'),
  LearningGuideMenuItemState: Symbol.for('learningGuide/LearningGuideMenuItemState')
};
